function verifyAge() {
  $(".pop-up").show();

  //when the button is clicked verify age and either remove popup or give message
  $("#agegateverified").click(function () {
    // if ($("#agegateverified").onclick == true) {
    $(".pop-up").fadeOut("slow");
    /*homepage animations trigger*/
    var ref = document.referrer.toLowerCase();
    // set cookie
    var cookURL = $.cookie("bas_referral", ref, {
      expires: 1,
    });
  });
  $("#agegatedenied").click(function () {
    $(".verify-message").html(
      "Apologies youngblood. You must be 21 to enter. Come back when youre older."
    );
    $("#agegateverified").attr("disabled", "");
  });
}

$(document).ready(function () {
  $(".toggle-nav").click(function () {
    if ($("nav").hasClass("navbar-open")) {
      $("nav").removeClass("navbar-open");
      $(".toggle-nav").removeClass("toggle-nav-open");
      $(".navbar ul").removeClass("nav-links-open");
      $(".logo-nav").removeClass("logo-nav-open");
      $(".content").removeClass("marg-top");
    } else {
      $("nav").addClass("navbar-open");
      $(".toggle-nav").addClass("toggle-nav-open");
      $(".navbar ul").addClass("nav-links-open");
      $(".logo-nav").addClass("logo-nav-open");
      $(".content").addClass("marg-top");
    }
  });
});
$(".navbar li").on("click", function (e) {
  if (!e.target.classList.contains("shopNow")) {
    $("nav").removeClass("navbar-open");
    $(".toggle-nav").removeClass("toggle-nav-open");
    $(".navbar ul").removeClass("nav-links-open");
    $(".logo-nav").removeClass("logo-nav-open");
    $(".content").removeClass("marg-top");
  }
});

$(".pop-up").removeClass("no-display");
$(".pop-up").hide();

jQuery.cookie = function (name, value, options) {
  if (typeof value != "undefined") {
    // name and value given, set cookie
    options = options || {};
    if (value === null) {
      value = "";
      options.expires = -1;
    }
    var expires = "";
    if (
      options.expires &&
      (typeof options.expires == "number" || options.expires.toUTCString)
    ) {
      var date;
      if (typeof options.expires == "number") {
        date = new Date();
        date.setTime(date.getTime() + options.expires * 24 * 60 * 60 * 1000);
      } else {
        date = options.expires;
      }
      expires = "; expires=" + date.toUTCString(); // use expires attribute, max-age is not supported by IE
    }
    // CAUTION: Needed to parenthesize options.path and options.domain
    // in the following expressions, otherwise they evaluate to undefined
    // in the packed version for some reason...
    var path = options.path ? "; path=" + options.path : "";
    var domain = options.domain ? "; domain=" + options.domain : "";
    var secure = options.secure ? "; secure" : "";
    document.cookie = [
      name,
      "=",
      encodeURIComponent(value),
      expires,
      path,
      domain,
      secure,
    ].join("");
  } else {
    // only name given, get cookie
    var cookieValue = null;
    if (document.cookie && document.cookie != "") {
      var cookies = document.cookie.split(";");
      for (var i = 0; i < cookies.length; i++) {
        var cookie = jQuery.trim(cookies[i]);
        // Does this cookie string begin with the name we want?
        if (cookie.substring(0, name.length + 1) == name + "=") {
          cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
          break;
        }
      }
    }
    return cookieValue;
  }
};

$(document).ready(function () {
  if ($.cookie("bas_referral") == null) {
    verifyAge();
  }
});

$(document).ready(function () {
  $(".text-reveal--anim").addClass("text-anim");
  let ordercta = document.querySelector(".order-cta");
  if (ordercta) {
    if (ordercta.getBoundingClientRect().top < window.innerHeight) {
      ordercta.classList.add("anim-trigger");
    }
  }

  // Rewards page order cta animation
  window.addEventListener("scroll", function (e) {
    if (ordercta) {
      if (ordercta.getBoundingClientRect().top < window.innerHeight) {
        ordercta.classList.add("anim-trigger");
      }
    }
  });
});

$(document).ready(() => {
  const isHoverable = window.matchMedia("(hover: hover)").matches;

  const shopButtonWrapper = document.querySelector("li.shopNow");
  const shopButton = shopButtonWrapper?.querySelector(".button");
  if (
    shopButton &&
    !isHoverable &&
    shopButtonWrapper.querySelector(".shopLinks")
  ) {
    // If there is no hover event and the shop now button has child links, prevent default on the main button click
    shopButton.addEventListener("click", (e) => {
      e.preventDefault();
    });
  }
});
